import React, { ChangeEvent, FocusEvent } from "react";
import {TextareaFieldCss} from "./TextFieldCss.tsx";

interface TextareaFieldProps {
    name: string;
    id?: string;
    value?: string;
    placeholder: string;
    labelName?: string;
    required?: boolean;
    maxLength?: number;
    register?: any;
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
    name,
    id = "",
    value,
    placeholder,
    labelName = "Description",
    required = false,
    maxLength = 200,
    register,
    onChange,
    onBlur,
}) => {

    return (
        <TextareaFieldCss>
            <label className="textarea__label">
                {labelName}
                {required && <span className="common__required">*</span>}
            </label>

            <div className="textarea-wrapper">
                <textarea
                    className="textarea-field"
                    name={name}
                    id={id}
                    value={value || ""}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    {...(register && register(name, { required }))}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                <span className="char-count">{`${value?.length||0}/${maxLength}`}</span>
            </div>
        </TextareaFieldCss>
    );
};

export default TextareaField;
